module.exports = __webpack_public_path__ + "media/images/bg/mosaic/sun-6be861b141d35c0e523da0336c267830.svg";